(function ($) {

	let _body = $('html, body');
	let _header = $('#site-header');
	let _overlay = $('.menu-overlay');
	let _mega = $('.mega-menu');
	let _allItem = $('.main-menu__item');
	let _search = $('.menu-search-wrapper');
	let _imitation = $('.menu-opacity');
	let _width = window.innerWidth;
	let prevScrollpos = window.pageYOffset;

	function scrollFunc() {
		const currentScrollPos = window.pageYOffset;
		prevScrollpos = currentScrollPos;

		if (currentScrollPos <= 100) {
			$('#site-header').removeClass('show-bg');
		} else {
			$('#site-header').addClass('show-bg');
		}
	}

	let vh = window.innerHeight * 0.01;
	document.documentElement.style.setProperty('--vh', `${vh}px`);

	window.addEventListener('resize', function () {
		vh = window.innerHeight * 0.01;
		document.documentElement.style.setProperty('--vh', `${vh}px`);
	});

	// const nativeOnscroll = window.onscroll;
	// Mega menu behavior
	$('.rhd-main-menu .main-menu__item').on('click', $.debounce(100, function (e) {

		let _this = $(this);
		let _scrollPos = window.pageYOffset;

		if ($(e.target).parents('.mega-menu').length > 0) {
			return;
		}

		if (_this.find('.mega-menu').length == 0 && !_this.hasClass('search')) {
			return;
		}

		if (_this.hasClass('active')) {

			if (_this.hasClass('search')) {
				_allItem.removeClass('active');
				_mega.stop(true).fadeOut(100);
				_search.stop(true).fadeOut(100);
				_header.removeClass('mega-menu-opened'); // Remove Mega Menu Open Class
				_overlay.stop(true).fadeOut(300); // Menu Overlay Disable
				_body.removeClass('lock'); // Enable Scroll
				_imitation.removeClass('hide'); // Disable Background
			} else {
				console.log(e.target);
				_allItem.removeClass('active');
				_mega.stop(true).fadeOut(100);
				_header.removeClass('mega-menu-opened');
				_overlay.stop(true).fadeOut(300); // Menu Overlay Disable
			}

			if (_scrollPos <= 100) {
				_header.removeClass('show-bg');
			} else {
				_header.addClass('show-bg');
			}
		} else {

			if (_this.hasClass('search')) {
				console.log('1');
				_allItem.removeClass('active');
				_mega.stop(true).fadeOut(100);
				_this.addClass('active');
				_header.removeClass('show-bg'); // Remove White Background
				_header.addClass('mega-menu-opened'); // Add Mega Menu Open Class
				_overlay.stop(true).fadeOut(300); // Menu Overlay Enable
				_body.addClass('lock'); // Disable Scroll
				_imitation.addClass('hide'); // Enable Background
				_search.stop(true).fadeIn(300); // Desktop Search
			} else {
				console.log('2');
				_header.addClass('mega-menu-opened'); // Add Mega Menu Open Class
				_overlay.stop(true).fadeIn(300); // Menu Overlay Enable
				_search.stop(true).fadeOut(100);
				_body.removeClass('lock'); // Enable Scroll
				_imitation.removeClass('hide'); // Disable Background

				_this.addClass('active');
				_this.find('.mega-menu').stop(true).fadeIn(300).promise().done(function () {
					_allItem.not(_this).removeClass('active');
					_allItem.not(_this).find('.mega-menu').stop(true).fadeOut(100);
					_header.removeClass('show-bg'); // Remove White Background
				});
			}
		}
	}));

	$(window).click(function (e) {

		let _scrollPos = window.pageYOffset;

		if ($('.rhd-main-menu .main-menu__item').hasClass('active')) {
			if ($(e.target).is('.menu-overlay') || $(e.target).parents('.main').length > 0) {
				_allItem.removeClass('active');
				_mega.stop(true).fadeOut(100);
				_header.removeClass('mega-menu-opened');
				_overlay.stop(true).fadeOut(300); // Menu Overlay Disable

				if (_scrollPos <= 100) {
					_header.removeClass('show-bg');
				} else {
					_header.addClass('show-bg');
				}
			}
		}
	});

	window.onscroll = scrollFunc;

	$('.search-font .small-size').click(function (e) {
		console.log('click small size');
		// mousein callback
		e.preventDefault();
		$('body').removeClass();

		$('body').addClass('small-font');
	});

	$('.search-font .normal-size').click(function (e) {
		// mousein callback
		e.preventDefault();
		$('body').removeClass();
	});

	$('.search-font .large-size').click(function (e) {
		console.log('click large size');
		// mousein callback
		e.preventDefault();
		$('body').removeClass();

		$('body').addClass('big-font');
	});

	$('.mobile-menu-toggle').click(function () {
		$('html, body').removeClass('mobile-search-open').toggleClass('mobile-menu-open');
		$('.mobile-search').stop(true).fadeOut(300);
		$('.mobile-nav-nav').stop(true).fadeToggle(300);
	});

	$('.mobile-main-menu .open-child-item').click(function () {
		let _target = $(this).attr('data-child');
		$('.mobile-nav-nav').addClass('open-child');
		$('.child-menu-item[data-parent=' + _target + ']').show();
	});

	$('.mobile-main-menu .child-menu-item_parent-item').click(function () {
		let _parent = $(this).parent('.child-menu-item');
		$('.mobile-nav-nav').removeClass('open-child');
		_parent.hide();
	});

	$('.mobile-main-menu .search').click(function () {
		$('html, body').removeClass('mobile-menu-open').toggleClass('mobile-search-open');
		$('.mobile-nav-nav').stop(true).fadeOut(300);
		$('.mobile-search').stop(true).fadeToggle(300);
	});

	$(window).resize(function () {
		_width = window.innerWidth;
		if (_width < 992) {
			$('.main-menu__item').removeClass('active');
			$('.menu-search-wrapper').hide();
			$('html,body').removeClass('lock');
			$('#site-header').removeClass('mega-menu-opened');
			_overlay.stop(true).fadeOut(300); // Menu Overlay Disable
			$('.menu-opacity').removeClass('hide');
		} else {
			$('.mobile-nav-nav,.mobile-search').hide();
			$('html,body').removeClass('mobile-search-open mobile-menu-open');
		}
	});

})(jQuery);
